const AdminCosts = ({ costs }) => (
  <div className="space-y-6" data-testid="admin-costs-tab">
    <div className="flex items-center justify-between">
      <h2 className="text-lg font-semibold text-white">AI / API Cost Tracking</h2>
      <div className="bg-violet-500/15 text-violet-300 px-3 py-1.5 rounded-lg text-sm font-medium">
        Total: ${(costs.total_api_cost || 0).toFixed(2)}/mo
      </div>
    </div>

    <div className="bg-slate-900/70 rounded-xl border border-white/5 overflow-hidden">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-white/5">
            <th className="text-left text-xs text-slate-400 font-medium px-4 py-3">Service</th>
            <th className="text-right text-xs text-slate-400 font-medium px-4 py-3">Calls</th>
            <th className="text-right text-xs text-slate-400 font-medium px-4 py-3">Cost</th>
            <th className="text-right text-xs text-slate-400 font-medium px-4 py-3">Trend</th>
          </tr>
        </thead>
        <tbody>
          {(costs.ai_api_costs || []).map((c) => (
            <tr key={c.service} className="border-b border-white/3 hover:bg-white/3">
              <td className="px-4 py-3 text-slate-200">{c.service}</td>
              <td className="px-4 py-3 text-right text-slate-300">{c.calls.toLocaleString()}</td>
              <td className="px-4 py-3 text-right font-medium text-white">${c.cost.toFixed(2)}</td>
              <td className="px-4 py-3 text-right">
                <span className={c.trend.startsWith("+") ? "text-red-400" : c.trend.startsWith("-") ? "text-emerald-400" : "text-slate-400"}>
                  {c.trend}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    {/* User Budget Category Breakdown */}
    {costs.by_category?.length > 0 && (
      <div className="bg-slate-900/70 rounded-xl border border-white/5 p-5">
        <h3 className="text-sm font-semibold text-white mb-4">User Budget by Category</h3>
        <div className="space-y-3">
          {costs.by_category.map((c) => (
            <div key={c.category} className="flex items-center justify-between">
              <span className="text-sm text-slate-300 capitalize">{c.category}</span>
              <span className="text-sm text-white font-semibold">
                {c.total.toLocaleString()} <span className="text-slate-500 font-normal text-xs">({c.count} items)</span>
              </span>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
);

export default AdminCosts;
